// extracted by mini-css-extract-plugin
export var FAQ_container = "FAQ_container-NjO";
export var FAQ_items = "FAQ_items-RnZ";
export var FAQ_with_sidebar = "FAQ_with_sidebar-v8b";
export var sidebar = "sidebar-8cY";